/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-script-url */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import moment from 'moment';
import * as toast from '../_store/slice/toast';
import server from '../_api/backend';

export function Login({ history }: RouteComponentProps) {
  const dispatch = useDispatch();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  useEffect(() => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('loginTime');
    window.localStorage.removeItem('name');
    window.localStorage.removeItem('college');
    window.localStorage.removeItem('department');
    window.localStorage.removeItem('email');
    window.localStorage.removeItem('part');
    window.localStorage.removeItem('authority');
  }, []);

  const onClickLogin = async () => {
    if (username.trim() === '') {
      dispatch(toast.error({ message: '아이디를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (password.trim() === '') {
      dispatch(toast.error({ message: '비밀번호를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    const loginPayload = {
      id: username,
      password,
    };
    const token = await server
      .signin(loginPayload)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.token) {
          window.localStorage.setItem('username', payload.username);
          window.localStorage.setItem('name', payload.name);
          window.localStorage.setItem('college', payload.college);
          window.localStorage.setItem('department', payload.department);
          window.localStorage.setItem('email', payload.email);
          window.localStorage.setItem('part', payload.part);
          window.localStorage.setItem('authority', payload.authority);
          return payload.token;
        }
        return undefined;
      })
      .catch((error) => {
        console.log(error);
      });
    if (token) {
      window.localStorage.setItem('token', token);
      window.localStorage.setItem('loginTime', moment().format());
      history.goBack();
    }
  };

  return (
    <main className="sub login wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>로그인</>
        </div>
        <section>
          <div className="login-content">
            <h2>로그인</h2>
            <div className="row">
              <label htmlFor="inputID">ID</label>
              <input
                id="inputID"
                type="text"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
              />
            </div>
            <div className="row">
              <label htmlFor="inputPassword">Password</label>
              <input
                id="inputPassword"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            <div className="checkbox">
              <input id="rememberID" type="checkbox" />
              <label htmlFor="rememberID">아이디 저장</label>
            </div>
            <button type="button" className="btn-main" onClick={onClickLogin}>
              로그인
            </button>
            <a href="/terms-policies">
              <button type="button" className="btn-signup">
                회원가입
              </button>
            </a>
            <a className="find-account" href="find-account">
              아이디/비밀번호 찾기
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Login;
